var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CircularProgress as MuiCircularProgress } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import { getAttributes } from '../../../utils';
import { Text, TextHtmlTags, TextVariants } from '../../atoms/text';
import { Container, ContainerDisplays, ContainerFlexAlignItems, ContainerFlexJustifyContents, ContainerPositions, ContainerRoles } from '../../templates/container';
import { GaugeVariants } from './types';
var MuiGauge = styled(Container, {
    name: 'MuiGauge',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
var G = function (_a) {
    var props = __rest(_a, []);
    var value = props.value, scale = props.scale, opacity = props.opacity, className = props.className, rest = __rest(props, ["value", "scale", "opacity", "className"]);
    var arcPercentage = 0.8;
    var scaleExists = Boolean(value) && Boolean(scale);
    var calculatedValue = scaleExists && value && scale ? (value / scale) * 100 : 0;
    var gaugeContainerConfig = __assign(__assign({ position: ContainerPositions.Relative, role: ContainerRoles.Meter }, (opacity && { className: 'opacity' })), { 'aria-valuemin': 0, 'aria-valuenow': value, 'aria-valuemax': scale, 'aria-valuetext': "".concat(value, "-out-of-").concat(scale), 'aria-label': "".concat(value, "-out-of-").concat(scale) });
    var gaugeConfig = __assign({ thickness: 6, variant: GaugeVariants.Determinate }, getAttributes(rest));
    var innerCircleConfig = __assign(__assign({}, gaugeConfig), { value: calculatedValue * arcPercentage, className: [className, 'gauge', 'inner-circle'].filter(Boolean).join(' '), 'aria-hidden': true });
    var outerCircleConfig = __assign(__assign({}, gaugeConfig), { value: 100 * arcPercentage, className: [className, 'gauge', 'outer-circle'].filter(Boolean).join(' '), 'aria-hidden': true });
    var gaugeValueWrapperConfig = {
        position: ContainerPositions.Absolute,
        display: ContainerDisplays.Flex,
        flexAlignItems: ContainerFlexAlignItems.Center,
        flexJustifyContent: ContainerFlexJustifyContents.Center,
        className: 'absolute-center'
    };
    var gaugeValueConfig = {
        content: String(value),
        isHtml: true,
        variant: TextVariants.H6,
        component: TextHtmlTags.Span
    };
    return (React.createElement(MuiGauge, __assign({}, gaugeContainerConfig),
        React.createElement(MuiCircularProgress, __assign({}, outerCircleConfig)),
        React.createElement(MuiCircularProgress, __assign({}, innerCircleConfig)),
        React.createElement(Container, __assign({}, gaugeValueWrapperConfig),
            React.createElement(Text, __assign({}, gaugeValueConfig)))));
};
export { G as Gauge };
